import "./assets/css/input.css";
import "./assets/css/scroll.css";
import "./assets/css/selectCustom.css";

import { ThemeProvider } from "@emotion/react";
import { AuthApi } from "api/auth";
import { isMobile } from "constants/common";
import { PATH } from "constants/path";
import { ResponseCode } from "constants/response";
import { ModalTypeValue } from "enums/modalType";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useAppLogout } from "hooks/useLogout";
import { useEffect, useRef } from "react";
import { Outlet, useNavigate, useSearchParams } from "react-router-dom";
import { getAnnouncement } from "store/announcement/announcement.thunk";
import { selectIsAuthenticated, selectToken, selectUsername } from "store/auth";
import { getGameList, getSubGamesFavourite } from "store/game/game.thunk";
import { setOpenModal, setOpenSubModal } from "store/master";
import { getMemberBalance, getProfile } from "store/user/user.thunk";
import GlobalStyles from "styles/global";
import { theme } from "styles/theme";

function App() {
  const dispatch = useAppDispatch();
  const onLogout = useAppLogout();

  const navigate = useNavigate();

  const isAuth = useAppSelector(selectIsAuthenticated);
  const token = useAppSelector(selectToken) || localStorage.getItem("token");
  const username =
    useAppSelector(selectUsername) || localStorage.getItem("username");

  const [searchParams] = useSearchParams();

  const code = searchParams.get("code");

  const appRef = useRef<NodeJS.Timeout | undefined>(undefined);
  const appActionRef = useRef<NodeJS.Timeout | undefined>(undefined);

  useEffect(() => {
    if (isMobile) {
      dispatch(setOpenSubModal(ModalTypeValue.MOBILE_NEWS));
      return;
    }
    dispatch(setOpenSubModal(ModalTypeValue.INFORMATION));
    dispatch(setOpenModal(ModalTypeValue.NEWS));
  }, []);

  useEffect(() => {
    checkUserLogin();
  }, [username]);

  useEffect(() => {
    dispatch(getGameList(""));
    dispatch(getAnnouncement({ type: 2 }));
  }, []);

  useEffect(() => {
    if (isAuth) {
      appRef.current = setInterval(fetchVerifyToken, 15 * 1000);
      handleInteraction();
    } else {
      clearInterval(appRef.current);
    }
  }, [isAuth]);

  useEffect(() => {
    if (!isMobile) return;

    if (isAuth) return;

    if (!code) return;

    navigate(`${PATH.Account.register}?code=${code}`);
  }, [isAuth]);

  const checkUserLogin = async () => {
    if (!username) return;
    try {
      const isSuccess = await fetchVerifyToken();

      if (!isSuccess) return;
      dispatch(getProfile(username));
      dispatch(getMemberBalance({ username }));
      dispatch(getSubGamesFavourite(username || ""));
    } catch (error) {}
  };

  const fetchVerifyToken = async () => {
    if (!username) return false;
    if (!token) return false;
    try {
      const response = await AuthApi.verifyToken(username, {
        username: username,
        token: token,
      });

      if (response.status !== ResponseCode.SUCCESS) {
        onLogout();
        return false;
      }

      return true;
    } catch (error) {
      return false;
    }
  };
  const handleInteraction = () => {
    if (appActionRef.current) {
      clearTimeout(appActionRef.current);
    }
    if (!isAuth) return;
    appActionRef.current = setTimeout(
      () => {
        onLogout();
      },
      1000 * 60 * 10,
    );
  };

  return (
    <div
      onMouseEnter={() => handleInteraction()}
      onKeyDown={() => handleInteraction()}
    >
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <Outlet />
      </ThemeProvider>
    </div>
  );
}

export default App;
